import type { AssetsFromClipboardData } from 'owa-timestream-asset-sdk-types';
import type { FluidPayload } from '../schema';
import { tryResolveDriverInfo } from '@ms/office-web-host';

export default function createFluidAssetFromClipboardData(
    getData: (format: string) => string
): AssetsFromClipboardData<FluidPayload> {
    const data = getData('text/html');
    try {
        if (data) {
            const parser = new DOMParser();
            const fragment = parser.parseFromString(data, 'text/html');
            const fluidUrlElement = fragment.querySelector(
                'span[fluid-url], div[fluid-url], a[fluid-url]'
            );
            if (fluidUrlElement) {
                const url = fluidUrlElement.attributes['fluid-url'].value;
                if (url) {
                    const driverInfo = tryResolveDriverInfo(url);
                    if (driverInfo) {
                        return [
                            {
                                type: 'fluid',
                                payload: { url },
                            },
                        ];
                    }
                }
            }
        }
    } catch {}
    return [null];
}
